import { useQuery } from '@tanstack/react-query';
import { remoteConfig } from '@/shared/lib/firebase';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { PricingConfig } from '../types';

export const pricingKeys = {
    all: ['pricing'] as const,
    config: () => [...pricingKeys.all, 'config'] as const,
};

export const usePricingConfig = () => {
    return useQuery<PricingConfig>({
        queryKey: pricingKeys.config(),
        queryFn: async () => {
            await fetchAndActivate(remoteConfig);
            const val = getValue(remoteConfig, 'PRICING_PLANS').asString();
            if (!val) throw new Error('Pricing configuration not found');
            return JSON.parse(val);
        },
        staleTime: 1000 * 60 * 60, // 1 hour
        gcTime: 1000 * 60 * 60 * 24, // 24 hours
    });
};
